const indexNav = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const links = Array.from(document.querySelectorAll('.js-index-link'));
    if (!links.length) return;

    const sections = links
      .map(link => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return null;
        return document.querySelector(href);
      })
      .filter(Boolean);

    if (!sections.length) return;

    const OFFSET = 150; // ヘッダー分など調整したい場合はここを変更

    const updateCurrentLink = () => {
      const scrollY = window.pageYOffset;
      let currentIndex = 0;

      for (let i = 0; i < sections.length; i++) {
        const sectionTop = sections[i].getBoundingClientRect().top + window.pageYOffset - OFFSET;
        if (scrollY >= sectionTop) {
          currentIndex = i;
        }
      }

      links.forEach((link, i) => {
        link.classList.toggle('is-current', i === currentIndex);
      });
    };

    window.addEventListener('scroll', updateCurrentLink, { passive: true });
    updateCurrentLink();
  });
};

export default indexNav();